import * as React from 'react';

import { ReactNativeDetectNotePitchViewProps } from './ReactNativeDetectNotePitch.types';

export default function ReactNativeDetectNotePitchView(props: ReactNativeDetectNotePitchViewProps) {
  return (
    <div>
      <span>{props.name}</span>
    </div>
  );
}
